export type VehicleSortKey = 'newest' | 'priceAsc' | 'priceDesc' | 'registration' | 'mileage';

export const VEHICLE_SORT_OPTIONS: { value: VehicleSortKey; label: string }[] = [
    { value: 'newest', label: 'Neuzugänge' },
    { value: 'priceAsc', label: 'Preis aufsteigend' },
    { value: 'priceDesc', label: 'Preis absteigend' },
    { value: 'registration', label: 'Erstzulassung' },
    { value: 'mileage', label: 'Kilometer' },
];

export const VEHICLE_PER_PAGE_OPTIONS = [12, 24, 48] as const;

export type VehiclePerPage = (typeof VEHICLE_PER_PAGE_OPTIONS)[number];

export const VEHICLE_DEFAULT_PER_PAGE: VehiclePerPage = 12;

/** Query parameters of the design: page and page size are shareable, filters are not. */
export const VEHICLE_PAGE_PARAM = 'seite';
export const VEHICLE_PER_PAGE_PARAM = 'pro_seite';

/** Slider steps. The ends of the scale are rounded outwards, so it spans every vehicle. */
export const VEHICLE_PRICE_STEP = 1000;
export const VEHICLE_MILEAGE_STEP = 1000;

export type VehicleView = 'grid' | 'list';
